import { Address } from 'viem'
import { arbitrum, avalanche, base, bsc, polygon } from 'viem/chains'
import { ChainId } from './interfaces'

export const bridgingCurrencies: {
  [chainId: number]: { symbol: string; address: Address; poolId: string }
} = {
  [avalanche.id]: {
    symbol: 'USDC',
    address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
    poolId: '1',
  },
  [polygon.id]: {
    symbol: 'USDC',
    address: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
    poolId: '1',
  },
  [arbitrum.id]: {
    symbol: 'USDC',
    address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
    poolId: '1',
  },
  [base.id]: {
    symbol: 'USDC',
    address: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
    poolId: '1',
  },
  [bsc.id]: {
    symbol: 'USDC',
    address: '0x55d398326f99059fF775485246999027B3197955',
    poolId: '2',
  },
}

const BRIDGING_CURRENCY: Record<ChainId, Record<ChainId, Address | undefined> | undefined> = {
  [arbitrum.id]: {
    [arbitrum.id]: undefined,
    [avalanche.id]: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
    [polygon.id]: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
  },
  [avalanche.id]: {
    [arbitrum.id]: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    [avalanche.id]: undefined,
    [polygon.id]: undefined,
  },
  [polygon.id]: {
    [arbitrum.id]: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    [avalanche.id]: undefined,
    [polygon.id]: undefined,
  },
  [base.id]: {
    [arbitrum.id]: undefined,
    [avalanche.id]: undefined,
    [polygon.id]: undefined,
    [bsc.id]: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca', //USDbC
  },
  [bsc.id]: {
    [arbitrum.id]: undefined,
    [avalanche.id]: undefined,
    [polygon.id]: undefined,
    [base.id]: '0x55d398326f99059fF775485246999027B3197955', //BSC-USD
  },
}

export const getBridging = (chainId: ChainId, remoteChainId: ChainId): Address => {
  if (BRIDGING_CURRENCY[chainId] === undefined) throw `Bridging currencies for ${chainId} not found`
  if (BRIDGING_CURRENCY[chainId]![remoteChainId] === undefined)
    throw `Bridging currency for ${remoteChainId} not found in ${chainId}`
  return BRIDGING_CURRENCY[chainId]![remoteChainId]!
}
